import { NoteSection } from '../../notes-page/components/NoteSection';
import { AddonCptCodesField, ProviderPrimaryCptCodeAutocomplete, ServerForm, ServerFormSection } from '@uplift/ui-v2';
import { ClaimCorrectionFormType, ProviderMedicalRole } from '@uplift/types';
import { useAmendSectionStyles } from './styles';
import { SessionFormField, SessionFormFieldsGroup } from '@uplift/api';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { NoteSectionCloseButton } from '../../notes-page/components/NoteSectionCloseButton';
import { useMemo } from 'react';
import { EMPTY_STRING } from '@uplift/constants';

export type AmendCptCodeSectionProps = {
  providerId: string;
  medicalRole: ProviderMedicalRole;
  open: boolean;
  cptCodeChangeReason: (SessionFormField | SessionFormFieldsGroup)[];
};

export const AmendCptCodeSection: React.VFC<AmendCptCodeSectionProps> = ({ providerId, medicalRole, open, cptCodeChangeReason }) => {
  const { classes } = useAmendSectionStyles();
  const formik = useFormikContext<ClaimCorrectionFormType>();

  const handleClose = () => {
    formik.setFieldValue('claim.cpt_field_toggle', false);
    formik.setFieldValue('claim.cpt_code_change_reason', null);
    formik.setFieldValue('cptCodes', null);
    formik.setFieldValue('addonCptCodes', []);
  };

  const closeIcon = useMemo(() => {
    if (formik?.values?.claim['cpt_code_change_reason'] !== null && formik?.values.claim['cpt_code_change_reason'] !== EMPTY_STRING) {
      return true;
    }
    if (formik.values.cptCodes !== null) {
      return true;
    }
    if (formik.values.addonCptCodes.length > 0) {
      return true;
    }
    return false;
  }, [ formik.values.addonCptCodes.length, formik.values?.claim, formik.values.cptCodes ]);

  if (!open) {
    return null;
  }

  return (
    <NoteSection
      title="Amend CPT codes"
      onDelete={<NoteSectionCloseButton onDelete={handleClose} closeIcon={closeIcon}/>}
      className={classes.noteSectionContent}
    >
      <Box className={classes.section}>
        <ServerForm fields={cptCodeChangeReason} namespace="claim"/>
      </Box>
      <Box className={classes.cptCodeSelect}>
        <ServerFormSection>
          <ProviderPrimaryCptCodeAutocomplete
            label="Primary CPT code"
            name="cptCodes"
            providerId={providerId}
            medicalRole={medicalRole}
          />
          <AddonCptCodesField
            name="addonCptCodes"
            providerId={providerId}
            buttonTextVariant
          />
        </ServerFormSection>
      </Box>
    </NoteSection>
  );
};
